import React, { useEffect, useState } from "react";
import {
  Briefcase,
  Calendar,
  Star,
  Video,
  Upload,
  MapPin,
  ChevronRight,
} from "lucide-react";
import { getAppliedRoleListForDrCr } from "../../../services/api";
import "./TalentDashboard.css";
import { Link } from "lucide-react";
const TalentDashboard = () => {
  const [applications, setApplications] = useState([]);

  // ✅ Load API Data
  useEffect(() => {
    const loadData = async () => {
      try {
        const res = await getAppliedRoleListForDrCr();
        setApplications(res?.data?.data || []);
      } catch (err) {
        console.error("API Error:", err);
        setApplications([]);
      }
    };

    loadData();
  }, []);

  // ✅ Status Badge
  const getStatusBadge = (status) => {
    return <span className={`td-status-badge ${status}`}>{status}</span>;
  };

  return (
    <div className="td-dashboard-wrapper">
      <div className="td-dashboard-container">

        {/* Header */}
        <div className="td-header-row">
          <h1 className="td-main-title">Dashboard</h1>
          <div className="td-welcome-text">
            Welcome back!
          </div>
        </div>

        {/* Stats */}
        <div className="td-stats-grid">
          <div className="td-card td-stat-card">
            <div className="td-stat-icon-box">
              <Briefcase size={20} />
            </div>
            <div>
              <h3 className="td-stat-number">{applications.length}</h3>
              <p className="td-stat-label">Applications</p>
            </div>
          </div>

          <div className="td-card td-stat-card">
            <div className="td-stat-icon-box">
              <Calendar size={20} />
            </div>
            <div>
              <h3 className="td-stat-number">
                {applications.filter(app => app.status === "scheduled").length}
              </h3>
              <p className="td-stat-label">Upcoming</p>
            </div>
          </div>

          <div className="td-card td-stat-card">
            <div className="td-stat-icon-box">
              <Star size={20} />
            </div>
            <div>
              <h3 className="td-stat-number">85%</h3>
              <p className="td-stat-label">Profile Score</p>
            </div>
          </div>
        </div>

        {/* Recent Applications */}
        <div className="td-section">
          <div className="td-section-header">
            <h2>Recent Applications</h2>
            <button className="td-view-all">View All</button>
          </div>

          <div className="td-card td-applications-card">
            {applications.length > 0 ? (
              <div className="td-applications-list">
                {applications.slice(0, 4).map((app, index) => (
                  <div
                    key={app.id || app.c_roleId || index}
                    className="td-application-item"
                  >
                    <div className="td-app-top">
                      <div className="td-app-left">

                        <div className="td-app-icon">
                          {app.type === "online-live" ? (
                            <Video size={16} />
                          ) : app.type === "online-self-tape" ? (
                            <Upload size={16} />
                          ) : (
                            <MapPin size={16} />
                          )}
                        </div>

                        <div className="td-app-text">
                          <h4>{app.projectName || "Untitled Project"}</h4>
                          <p>
                            {app.roleTitle ||
                              app.c_roleName ||
                              app.title ||
                              app.characterName ||
                              "Role"}
                          </p>
                        </div>
                      </div>

                      <div className="td-arrow-link">
                        <ChevronRight size={16} />
                      </div>
                    </div>

                    <div className="td-app-meta">
                      <span className="td-app-date">
                        {app.createdAt
                          ? new Date(app.createdAt).toLocaleDateString()
                          : "Recent"}
                      </span>

                      {getStatusBadge(app.status || "applied")}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="td-empty-state">
                    <p>You haven't applied for any roles yet.</p>
                    <Link to="/roles">
                      <button className="td-browse-btn">Browse Roles</button>
                    </Link>
                  </div>
            )}
          </div>
        </div>

        {/* Recommended */}
        <div className="td-section">
          <h2 className="td-recommend-title">Recommended for You</h2>

          <div className="td-recommend-grid">
            {[1, 2].map((item) => (
              <div className="td-card td-recommend-card" key={item}>
                <div className="td-match-badge">95% Match</div>

                <p className="td-genre-text">ACTION THRILLER</p>
                <h3 className="td-role-title">Undercover Agent</h3>

                <p className="td-role-desc">
                  Looking for an actor with martial arts experience and intense screen presence.
                </p>

                <button className="td-view-role-btn">
                  View Role
                </button>
              </div>
            ))}
          </div>
        </div>

      </div>
    
      
    </div>




  );
};

export default TalentDashboard;